import { getHelpCenterAri } from '@helpcenter/meta';
import { createResource } from 'react-resource-router';
import type { MediaApiUploadToken } from 'rest/portal';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri } from '@atlassian/ari';
import { fetchJson } from '@atlassian/help-center-common-util/fetch/fetch';

export const mediaUploadCredentialsResource = createResource<MediaApiUploadToken>({
	type: 'MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
	getKey: () => `media-upload-credentials`,
	getData: async () => {
		const { helpCenterId } = HelpHelpCenterAri.parse(getHelpCenterAri());
		return fetchJson(`/rest/jcs/internal/1/support-site/${helpCenterId}/media/credentials/upload`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		});
	},
	maxAge: 0,
});
